import React, { useEffect, useRef, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { motion, useAnimation } from "framer-motion"; // Import motion and useAnimation
import { useInView } from "react-intersection-observer";
import Images from "../../assets/Image";

import frame4 from "../../assets/frame1.png";
import frame5 from "../../assets/frame2.png";
import frame6 from "../../assets/frame3.png";
import UpcomingEvent from "./UpcomingEvent";
import PastEvent from "./PastEvent";
import ContactUsFooter from "../ContactUsFooter";

const images = [frame4, frame5, frame6];

const EventComp = () => {
  return (
    <>
      <div className="event_heading_block">
        <div className="event_heading_sub_block">
          <h6 className="event_heading">EVENTS & TRADE SHOW</h6>
          <h6 className="event_heading_content">
            USP PACKING SOLUTION GUARANTED OUTCOMES WITH UNIQUE
          </h6>
          <h6 className="event_heading_content">
            EVENTS & TRADE SHOW SERVICES
          </h6>
        </div>
      </div>
      <div className="event_heading_content__block">
        <div className="event_title_content_block  fade-slide-down">
          <h6 className="event_content_para_heading">
            Trade Shows Can Give You a Competitive Edge in Business
          </h6>
          <p className="event_content_para">
            Trade shows offer a significant competitive edge for businesses in
            the printing and packaging industry, providing an unmatched
            opportunity to showcase innovations, build relationships, and set
            yourself apart from competitors. In this rapidly evolving field,
            trade shows let you demonstrate the latest in printing technologies,
            sustainable materials, and innovative packaging solutions, giving
            prospective clients a hands-on experience with your products. You
            can engage directly with key decision-makers and potential partners,
            building trust and fostering relationships that might be difficult
            to establish online. Trade shows also offer valuable market
            insights, allowing you to see competitor offerings up close and to
            understand emerging trends—such as eco-friendly packaging or digital
            printing advancements—that are driving industry demand. By
            participating in these events, your brand gains exposure,
            credibility, and the chance to position itself as a forward-thinking
            leader, securing a foothold in an industry where staying current and
            innovative is key to long-term success.
          </p>
        </div>
      </div>
      <h6 className="event_content_para_heading">Upcoming Event</h6>
      <UpcomingEvent />

      <h6 className="event_content_para_heading my-5">Past Event</h6>

      <PastEvent />
      <ContactUsFooter />
    </>
  );
};

export default EventComp;
